(ns splash.ui.lender-portal.common.auth
  (:require
    ["@azure/msal-browser" :as msal]
    [splash.ui.lender-portal.config :as config]
    [splash.ui.lender-portal.datadog :as datadog]))

(defn extract-user-info
  [msal-instance]
  (let [activeAccount (js->clj (.getActiveAccount msal-instance))
        email         (get activeAccount "username")
        full-name     (get activeAccount "name")
        user          {:id    (str (random-uuid))
                       :email email
                       :name  full-name}]
    (datadog/set-user-info user)))

(defn initialize-msal-instance
  []
  (let [msal-config (clj->js (config/get-config :msal))
        tenant-id (:msal-tenant-id (config/get-config :msal))
        msal-instance (msal/PublicClientApplication. msal-config)]
    ;; Default to using the first account if no account is active on page load
    (when (and (nil? (.getActiveAccount msal-instance))
            (> (count (.getAllAccounts msal-instance)) 0))
      ;; Account selection logic is app dependent. Adjust as needed for different use cases.
      (when-let [matching-account (->> (.getAllAccounts msal-instance)
                                    (filter #(= tenant-id (.-tenantId %)))
                                    first)]
        (.setActiveAccount msal-instance matching-account)
        (extract-user-info msal-instance)))

    (when (some? (.getActiveAccount msal-instance))
      (extract-user-info msal-instance)
      (js/console.debug "Active account found"))

    ;; Listen for sign-in event and set active account
    (.addEventCallback msal-instance
      (fn [event]
        (when-let [account (and (= (.-eventType event) msal/EventType.LOGIN_SUCCESS)
                             (.. event -payload -account))]
          (.setActiveAccount msal-instance account)
          (extract-user-info msal-instance))))
    (.then (.initialize msal-instance)
      #(js/Promise.resolve msal-instance))))

(defn msal-scopes
  []
  [(str (config/get-config [:msal "auth" "clientId"]) "/.default")])

(defn acquire-token
  [msal-instance]
  (let [request (clj->js {:scopes (msal-scopes)})]
    (-> (.acquireTokenSilent msal-instance request)
      (.catch (fn [error]
                (if (instance? (.-InteractionRequiredAuthError msal) error)
                  (-> (.loginPopup msal-instance request)
                    (.then #(js/Promise.resolve (.-accessToken %))))
                  (.error js/console error))))
      (.then #(js/Promise.resolve (.-accessToken %))))))
